import { Typography } from '@material-ui/core';
import React from 'react';
import { LinearProgressWithLabel } from './Modals/OI Modal/functions';

const Loading = ({ text = 'Verifying' }) => {
  return (
    <div
      style={{
        height: '100%',
        position: 'absolute',
        top: '50%',
        width: '100%',
      }}
    >
      <div>
        <LinearProgressWithLabel />
        <Typography
          variant='body2'
          color='secondary'
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.jsx